/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import initAutocomplete from '@/js/components/autocomplete'

/**
 * Mount the global autocomplete (Algolia + custom plugins) on `#autocomplete`.
 * The returned cleanup destroys the autocomplete instance and unbinds hotkeys
 * on disconnect.
 *
 * @type {Listener}
 */
export default {
    selector: '#autocomplete',
    connect(_element, { app }) {
        // The component resolves `#autocomplete` itself (document-wide default)
        // and bails when the element is not visible.
        return initAutocomplete({ app })
    },
}
